.root {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.header {
  padding: var(--tuna-spacing) 0;
}

.title {
  margin: 0;
}

.title:focus {
  outline: none;
}

.title:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: calc(var(--tuna-spacing) * 2);
  padding-bottom: calc(var(--tuna-spacing) * 2);
}

.message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing);
}

.details h4 {
  margin: 0 0 var(--tuna-spacing);
}

.fieldList {
  margin: 0;
  padding-left: calc(var(--tuna-spacing) * 2);
}

.lines {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Lines wrap, never scroll sideways; long chord lines wrap at spaces */
.row {
  display: flex;
  gap: var(--tuna-spacing);
  padding: 2px var(--tuna-spacing);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.glyph {
  flex-shrink: 0;
  width: 1ch;
}

.text {
  flex: 1;
  min-width: 0;
}

.heading {
  font-weight: var(--tuna-typography-fontWeight-bold);
}

/* The glyph, the strikethrough and the weight carry the meaning; the tint only supports it (WCAG 1.4.1) */
.added {
  background-color: color-mix(in srgb, var(--tuna-feedback-success) 16%, transparent);
  color: var(--tuna-content-primary);
}

.removed {
  background-color: color-mix(in srgb, var(--tuna-feedback-error) 16%, transparent);
  color: var(--tuna-content-primary);
}

.removed .text {
  text-decoration: line-through;
}

/* The glyph in the feedback text colour gives the + and − more presence; the line text stays content-primary (Joni) */
.added .glyph {
  color: var(--tuna-feedback-success-text);
}

.removed .glyph {
  color: var(--tuna-feedback-error-text);
}

.added strong,
.removed strong {
  font-weight: var(--tuna-typography-fontWeight-bold);
}

.collapsed {
  padding: 2px 0;
}

.collapsedButton {
  min-height: 32px;
  padding: 0 var(--tuna-spacing);
  border: none;
  background: none;
  color: var(--tuna-content-secondary);
  cursor: pointer;
  text-decoration: underline;
  font: inherit;
}

.footer {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  gap: var(--tuna-spacing);
  padding: var(--tuna-spacing) 0;
  background-color: var(--tuna-surface-default);
}

/* Phones: 44px targets in the sticky footer */
@media (max-width: 599.95px) {
  .footer button,
  .collapsedButton {
    min-height: 44px;
  }
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
